exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".musteri-karlilik-report-table[data-v-4a33ed3f]{width:100%;margin-top:4px}.musteri-karlilik-report-table>*[data-v-4a33ed3f]{width:100%}", ""]);

// exports
